module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 32);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIwankeyIeg3rd", function() { return getIwankeyIeg3rd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paramsHandle", function() { return paramsHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIPad", function() { return isIPad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isQQBrowser", function() { return isQQBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isGameMsdk", function() { return isGameMsdk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isQQLive", function() { return isQQLive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isQQLite", function() { return isQQLite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIwanBrowser", function() { return isIwanBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIwanVersion", function() { return getIwanVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTadChid", function() { return isTadChid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTenvideo", function() { return isTenvideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLiteTenvideo", function() { return isLiteTenvideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isWeishi", function() { return isWeishi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSports", function() { return isSports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isYYB", function() { return isYYB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIwanAPP", function() { return isIwanAPP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBBG", function() { return isBBG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isApp", function() { return isApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isWechat", function() { return isWechat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isQQ", function() { return isQQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatQQ", function() { return formatQQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOpenOpenid", function() { return getOpenOpenid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOpenAccessToken", function() { return getOpenAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkQQ", function() { return checkQQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkWX", function() { return checkWX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkVUserId", function() { return checkVUserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOs", function() { return getOs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPhoneSystem", function() { return getPhoneSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatform", function() { return getPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRiskPlatform", function() { return getRiskPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatformId", function() { return getPlatformId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "token", function() { return token; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPage", function() { return getPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterXSS", function() { return filterXSS; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__);




// ieg3.0版本上报 获取iwankey
var getIwankeyIeg3rd = function getIwankeyIeg3rd() {
  var _location;
  var outerIwankey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _urlToJson = Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["urlToJson"])(),
    actpayid = _urlToJson.actpayid,
    reportParams = _urlToJson.reportParams;
  if (reportParams && reportParams.indexOf('iwan') > -1) {
    // 如果reportParams包含iwan，返回reportParams
    return reportParams;
  }
  ;

  // 如果reportParams不包含iwan，返回`iwan_channel-${actpayid}_rpk`
  if (actpayid) {
    return "iwan_channel-".concat(actpayid, "_rpk");
  }

  // 优先url获取，若无则使用外部传参
  if (!!outerIwankey) return outerIwankey;

  // 默认返回
  var defaultIwankeyObj = {
    'iwan.qq.com': 'iwan_settlement-resource_pos-1000110_rpk',
    // 游戏中心默认
    'apptest.iwan.qq.com': 'iwan_settlement-resource_pos-1000110_rpk',
    // 游戏中心测试环境默认
    'a.iwan.qq.com': 'iwan_settlement-resource_pos-1000111_rpk',
    // 活动默认
    'a-test.iwan.qq.com': 'iwan_settlement-resource_pos-1000111_rpk',
    // 活动测试环境默认
    's.iwan.qq.com': 'iwan_settlement-resource_pos-1000114_rpk',
    // 卡牌默认
    's-test.iwan.qq.com': 'iwan_settlement-resource_pos-1000114_rpk',
    // 卡牌测试环境默认
    'test.film.video.qq.com': 'iwan_settlement-resource_pos-1000133_rpk',
    // vip活动页兜底
    'film.video.qq.com': 'iwan_settlement-resource_pos-1000133_rpk' // vip活动页测试环境兜底
  };
  return defaultIwankeyObj[(_location = location) === null || _location === void 0 ? void 0 : _location.host] || '';
};

/**
 * 处理多个方法的参数
 * @param {*} params
 */
var paramsHandle = function paramsHandle() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _params = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(params, 3),
    _params$ = _params[0],
    opts = _params$ === void 0 ? {} : _params$,
    _params$2 = _params[1],
    succCb = _params$2 === void 0 ? function () {} : _params$2,
    _params$3 = _params[2],
    failCb = _params$3 === void 0 ? function () {} : _params$3;
  var res = params;
  if (Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["isObject"])(opts)) {
    res = {
      opts: opts,
      succCallback: succCb,
      failCallback: failCb
    };
  }
  if (Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["isFunction"])(opts)) {
    res = {
      opts: {},
      succCallback: opts,
      failCallback: succCb
    };
  }
  return res;
};

/**
 * 判断是ipad情况
 */
var isIPad = function isIPad() {
  return /(iPad).*OS\s([\d_]+)/.test(navigator.userAgent);
};

/**
 * 判断是qq浏览器
 */
var isQQBrowser = function isQQBrowser() {
  var ua = window.navigator.userAgent;
  return ua.indexOf('MQQBrowser') > -1;
};

/**
 * 判断是否在游戏内MSDK浏览器打开
 */
var isGameMsdk = function isGameMsdk() {
  var _urlToJson2 = Object(_tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["urlToJson"])(),
    msdkEncodeParam = _urlToJson2.msdkEncodeParam,
    itopencodeparam = _urlToJson2.itopencodeparam;
  return msdkEncodeParam || itopencodeparam;
};

/**
 * tenvideo标记
 */
var isQQLive = function isQQLive() {
  var ua = window.navigator.userAgent;
  return ua.indexOf('QQLiveBrowser') > -1 || ua.indexOf('QQLiveHDBrowser') > -1;
};

/**
 * lite tenvideo app标记
 */
var isQQLite = function isQQLite() {
  var ua = window.navigator.userAgent;
  return ua.indexOf('QQLiteBrowser') > -1;
};

/**
 * 爱玩 app标记
 */
var isIwanBrowser = function isIwanBrowser() {
  var ua = window.navigator.userAgent;
  return ua.indexOf('IwanBrowser') > -1;
};

/**
 * 获取爱玩app版本号
 */
var getIwanVersion = function getIwanVersion() {
  var ua = window.navigator.userAgent;
  var versionReg = /iwanBrowser\/(\d+\.\d+\.\d+)/i.exec(ua);
  var version = versionReg ? versionReg[1] : '0.0.0';
  return version;
};

/**
 * 判断是否是 内广webview
 * 内广webview 潜在视频app中，ua会有视频的标记，但是不能使用视频的jsbridge
 * 当普通浏览器来处理
 */
var isTadChid = function isTadChid() {
  var ua = window.navigator.userAgent;
  return ua.indexOf('TadChid') > -1 || ua.indexOf('TADChid') > -1;
};

/**
 * 是否是腾讯视频 app
 */
var isTenvideo = function isTenvideo() {
  return isQQLive() && !isTadChid() && !isLiteTenvideo() && !isBBG();
};

/**
 * 是否是腾讯视频极速版 app
 */
var isLiteTenvideo = function isLiteTenvideo() {
  return isQQLite() && !isTadChid();
};

/**
 * 是否是微视 app
 */
var isWeishi = function isWeishi() {
  var ua = window.navigator.userAgent;
  return /WEISHI_(\d+(\.\d+)*)/i.test(ua) || ua.indexOf('ilive') > -1;
};

/**
 * 是否是体育 app
 */
var isSports = function isSports() {
  var ua = window.navigator.userAgent;
  return /qqsports/i.test(ua);
};

/**
 * 是否是应用宝 app
 */
var isYYB = function isYYB() {
  var ua = window.navigator.userAgent;
  return /qqdownloader\/(\d+)/i.test(ua);
};

/**
 * 是否是爱玩APP
 */
var isIwanAPP = function isIwanAPP() {
  return isIwanBrowser();
};

/**
 * 是否是BBG app
 */
var isBBG = function isBBG() {
  var ua = window.navigator.userAgent;
  return /com.tencent.bbg/.test(ua);
};

/**
 * 判断是否是app
 */
var isApp = function isApp() {
  return isTenvideo() || isLiteTenvideo() || isIwanAPP() || isWeishi() || isSports() || isYYB() || isBBG();
};

/**
 * 判断是否是微信
 */
var isWechat = function isWechat() {
  var ua = window.navigator.userAgent;
  return ua.indexOf('MicroMessenger') > -1;
};

/**
 * 判断是否是手Q
 */
var isQQ = function isQQ() {
  var ua = window.navigator.userAgent;
  return /QQ[\s/]*(\d+(\.\d+)*)/i.test(ua);
};

/**
 * 格式化 qq
 * @param {*} qq
 */
var formatQQ = function formatQQ(str) {
  return "".concat(str).replace(/(o+)?(0+)?/, '');
};

/**
 * 获取互联登录态
 * open_openid 后期会废弃
 * 统一使用tenvideo vqq_openid
 */
var getOpenOpenid = function getOpenOpenid() {
  var openOpenid = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('open_openid');
  var vqqOpenid = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('vqq_openid');
  return openOpenid || vqqOpenid;
};

/**
 * 获取互联登录态
 * open_access_token 后期会废弃
 * 统一使用tenvideo vqq_access_token
 */
var getOpenAccessToken = function getOpenAccessToken() {
  var openAccessToken = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('open_access_token');
  var vqqAccessToken = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('vqq_access_token');
  return openAccessToken || vqqAccessToken;
};

/**
 * 根据host判断当前活动页面场景
 */
var checkSceneByHost = function checkSceneByHost() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return location.host && location.host.includes(domain);
};

/**
 * 检查cookie中某个字段是否等于某值
 */
var isCookieEqualToValue = function isCookieEqualToValue() {
  var cookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var cookieValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get(cookieName) === cookieValue;
};

/**
 * 检查是否是有qq登录相关的cookie
 */
var checkQQ = function checkQQ() {
  // 应用宝登录的cookie
  if (checkSceneByHost(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__["DOMAIN_MAP"].yyb)) {
    // 端内
    if (isYYB()) {
      return isCookieEqualToValue('logintype', 'MOBILEQ');
    }

    // 端外
    return isCookieEqualToValue('yyb_logintype', 'qq');
  }

  // 微视登录的cookie
  if (checkSceneByHost(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__["DOMAIN_MAP"].weishi)) {
    return isCookieEqualToValue('iAuthType', '1');
  }

  // bbg登录的cookie
  if (checkSceneByHost(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__["DOMAIN_MAP"].bbg)) {
    return isCookieEqualToValue('bbg_mainlogin', 'qq');
  }

  // 动漫登录的cookie
  if (checkSceneByHost(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__["DOMAIN_MAP"].ac)) {
    return isCookieEqualToValue('act_account_type', 'qq');
  }

  // const uin = cookie.get('uin');
  // const skey = cookie.get('skey');
  // const openOpenid = getOpenOpenid();
  // const openAccessToken = getOpenAccessToken();

  // return (uin.length > 4 && skey.length > 0) || (openOpenid && openAccessToken);
  var mainLogin = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('main_login');
  return mainLogin === 'qq';
};

/**
 * 检查是否是有wx登录相关的cookie
 */
var checkWX = function checkWX() {
  // 应用宝登录的cookie
  if (checkSceneByHost(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__["DOMAIN_MAP"].yyb)) {
    // 端内
    if (isYYB()) {
      return isCookieEqualToValue('logintype', 'WX');
    }

    // 端外
    return isCookieEqualToValue('yyb_logintype', 'wx');
  }

  // 微视登录的cookie
  if (checkSceneByHost(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__["DOMAIN_MAP"].weishi)) {
    return isCookieEqualToValue('iAuthType', '3');
  }

  // bbg登录的cookie
  if (checkSceneByHost(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__["DOMAIN_MAP"].bbg)) {
    return isCookieEqualToValue('bbg_mainlogin', 'wx');
  }

  // 动漫登录的cookie
  if (checkSceneByHost(_tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__["DOMAIN_MAP"].ac)) {
    return isCookieEqualToValue('act_account_type', 'wx');
  }

  // return cookie.get('openid');
  var mainLogin = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('main_login');
  return mainLogin === 'wx';
};

/**
 * 检查是否有 tenvideo 登录台
 */
var checkVUserId = function checkVUserId() {
  var vuserid = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('vuserid');
  var vusession = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('vusession');
  var vqqVuserid = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('vqq_vuserid');
  var vqqVusession = _tencent_txv_utils__WEBPACK_IMPORTED_MODULE_1__["cookie"].get('vqq_vusession');
  return vuserid && vusession || vqqVuserid && vqqVusession;
};

/**
 * 获取系统类型
 */
var getOs = function getOs() {
  var ua = window.navigator.userAgent;
  var os = 'pc';
  if (ua.indexOf('Android') > -1) {
    os = 'android';
  } else if (/(iPhone|iPod|iPad)/.test(ua)) {
    os = 'ios';
  }
  return os;
};

/**
 * 获取手机系统
 * @returns {string} ios | android(默认)
 */
var getPhoneSystem = function getPhoneSystem() {
  var ua = window.navigator.userAgent;
  var os = 'android';
  if (/(iPhone|iPod|iPad)/.test(ua)) {
    os = 'ios';
  }
  return os;
};

/**
 * @param {Function} fn
 * 如果 simple = 1，则返回 app，或者浏览器
 * 默认返回详细的平台，比如微信、qq、qq浏览器等
 * 使用场景: 当各个 app有不同的放法，微信、qq、qq浏览器、浏览器的某个方法都一样的时候，会用到此参数
 * 额外场景：当某个app的bridge能力覆盖不全时，不填simple参数，会以浏览器为基础向上累加bridge方法
 * 默认返回 browser
 */
var getPlatform = function getPlatform(fn) {
  // 过滤 platform的方法，调用者可传入自己的filter，获取想要的 platform
  var filterMethod = fn || function (item) {
    return item.env;
  };
  var platformList = [{
    simple: 1,
    qrcode: 1,
    env: 'tenvideo',
    check: isTenvideo
  }, {
    simple: 1,
    env: 'lite',
    check: isLiteTenvideo
  }, {
    simple: 1,
    env: 'iwan',
    check: isIwanAPP
  }, {
    qrcode: 1,
    env: 'wx',
    check: isWechat
  }, {
    qrcode: 1,
    env: 'qq',
    check: isQQ
  }, {
    env: 'weishi',
    check: isWeishi
  }, {
    env: 'sports',
    check: isSports
  }, {
    env: 'yyb',
    check: isYYB
  }, {
    env: 'bbg',
    check: isBBG
  }, {
    env: 'qqbrowser',
    check: isQQBrowser
  }, {
    qrcode: 1,
    simple: 1,
    env: 'browser',
    check: function check() {
      return true;
    }
  }];
  return platformList.filter(filterMethod).find(function (item) {
    return item.check();
  }).env;
};

/**
 * 获取深圳风控系统平台id
 * ipad优先为4，之后ios 5，andorid 3，pc 2
 */
var getRiskPlatform = function getRiskPlatform() {
  var riskPlatform = {
    pc: 2,
    android: 3,
    ios: 5,
    iPad: 4
  };
  var plat = isIPad() ? 'iPad' : getOs();
  return riskPlatform[plat];
};

/**
 * 获取平台id
 */
var getPlatformId = function getPlatformId() {
  var system = getPhoneSystem();
  var platform = getPlatform();
  return _tencent_txv_athena_variable__WEBPACK_IMPORTED_MODULE_2__["PLATFORM_CONF"][system][platform];
};

/**
 * 和后端保持统一 token 生成规则
 * @param {*} cookieValue
 */
var token = function token() {
  var cookieValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var hash = 5381;
  for (var i = 0, len = cookieValue.length; i < len; i++) {
    hash += (hash << 5) + cookieValue.charCodeAt(i);
  }
  hash = hash & 0x7fffffff;
  return hash;
};

/**
 * 获取页面标记
 * 用来判断是哪个页面
 */
var getPage = function getPage() {
  var _location2 = location,
    pathname = _location2.pathname;
  var index = pathname.lastIndexOf('/') + 1;
  var page = pathname.slice(index);
  return page.split('.')[0];
};

/**
 * 处理接口返回的用户昵称中包含特殊字符
 */
var filterXSS = function filterXSS(str) {
  return str.replace(/&/g, '&amp;').replace(/ /g, '&nbsp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r{0,}\n/g, '<br/>');
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/variable");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ })

/******/ });